import * as React from 'react';
import { ModalContent } from './components/ModalContent';
import { ModalHeader } from './components/ModalHeader';
import { OffersTable } from '../OffersTable';
import { Skeleton } from './components/Skeleton';
import { ErrorScreen } from './components/ErrorScreen';
import { useOffers } from '../../../../hooks';
import { useCompareRequests } from '../../../../hooks/useCompareRequests';
import { CompareNotificationContainer } from '../CompareNotification';
import { OffersContext } from '../../../../shared/context';
import { useFavorite } from '../../../../hooks/useFavorite';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OffersModalContainer = _ref => {
  let {
    contactsButton,
    houseId,
    layoutKey,
    newbuildingId
  } = _ref;
  const {
    layout,
    contact,
    onRetry,
    error,
    loading,
    setComparisonStatus,
    setFavoriteStatus
  } = useOffers({
    houseId,
    layoutKey,
    newbuildingId
  });
  const {
    addOfferToComparison,
    removeOfferFromComparison,
    clearNotification,
    notification
  } = useCompareRequests({
    setComparisonStatus
  });
  const {
    addOfferToFavorites,
    removeOfferFromFavorites
  } = useFavorite({
    setFavoriteStatus
  });
  const context = React.useMemo(() => ({
    layout: layout,
    addOfferToComparison,
    removeOfferFromComparison,
    addOfferToFavorites,
    removeOfferFromFavorites
  }), [layout, addOfferToComparison, removeOfferFromComparison, addOfferToFavorites, removeOfferFromFavorites]);
  if (error) {
    return /*#__PURE__*/_jsx(ErrorScreen, {
      onRetry: onRetry
    });
  }
  if (loading || !layout) {
    return /*#__PURE__*/_jsx(Skeleton, {});
  }
  return /*#__PURE__*/_jsx(OffersContext.Provider, {
    value: context,
    children: /*#__PURE__*/_jsxs(ModalContent, {
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        contactsButton: contactsButton,
        contact: contact
      }), /*#__PURE__*/_jsx(OffersTable, {}), /*#__PURE__*/_jsx(CompareNotificationContainer, {
        notification: notification,
        clearNotification: clearNotification
      })]
    })
  });
};